export default __webpack_public_path__ + "static/media/e-money.876e4c73.png";